import React from "react";
import { FaTrash, FaPhoneAlt } from "react-icons/fa";
import { formatDateTime } from '../../helpers/formatDateTime';
import Pagination from "../../helpers/Pagination"; // Import panniachu

const DuplicateClientsTable = ({ groups, pagination, onPageChange, onLimitChange, onDeleteClick }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          {/* ... Table Head Same as your code ... */}
          <thead className="bg-gray-50 text-gray-600 uppercase text-xs font-semibold">
            <tr>
              <th className="px-6 py-4 whitespace-nowrap">Client Info</th>
              <th className="px-6 py-4">Industry</th>
              <th className="px-6 py-4">Stage</th>
              <th className="px-6 py-4 whitespace-nowrap">Created Date</th>
              <th className="px-6 py-4 whitespace-nowrap">Created By</th>
              <th className="px-6 py-4">Status</th>
              <th className="px-6 py-4 whitespace-nowrap">Deleted Date</th>
              <th className="px-6 py-4 whitespace-nowrap">Deleted By</th>
              <th className="px-6 py-4 text-center">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {groups.map((group) => (
              <React.Fragment key={group._id}>
                <tr className="bg-blue-50/50">
                  <td colSpan="9" className="px-6 py-2 font-bold text-blue-700 text-sm">
                    <div className="flex items-center gap-2">
                      <FaPhoneAlt size={12} /> Phone: {group._id} 
                      <span className="bg-blue-200 px-2 rounded-full text-[10px]">{group.count} Duplicates</span>
                    </div>
                  </td>
                </tr>
                {group.clients.map((client) => (
                  <tr key={client._id} className="hover:bg-gray-50">
                    <td className="px-6 py-4">
                      <div className="font-medium">{client.clientName}</div>
                      <div className="text-xs text-gray-400">{client.clientId}</div>
                    </td>
                    <td className="px-6 py-4 text-sm">{client.industryType}</td>
                    <td className="px-6 py-4 text-sm">{client.currentStage}</td>
                    <td className="px-6 py-4 text-sm">{formatDateTime(client.createdAt, false)}</td>
                    <td className="px-6 py-4 text-sm">
                      {client.createdBy ? `${client.createdBy.firstName} ${client.createdBy.lastName}` : "N/A"}
                    </td>
                    <td className="px-6 py-4">
                      <span className={`px-2 py-1 rounded-full text-xs ${client.isDeleted ? "bg-red-100 text-red-700" : "bg-green-100 text-green-700"}`}>
                        {client.isDeleted ? "Deleted" : "Active"}
                      </span>
                    </td>
                    <td className="px-6 py-4 text-sm">{formatDateTime(client.deletedAt, false)}</td>
                    <td className="px-6 py-4 text-sm">
                    {client.deletedBy?.firstName
                        ? `${client.deletedBy.firstName} ${client.deletedBy.lastName || ""}`.trim()
                        : "N/A"}
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button onClick={() => onDeleteClick(client)} className="text-red-500 hover:bg-red-50 p-2 rounded-full">
                        <FaTrash size={16} />
                      </button>
                    </td>
                  </tr>
                ))}
              </React.Fragment>
            ))}
          </tbody>
        </table>
      </div>

      {/* Reusable Pagination Component Use Panniyaachu */}
      <div className="p-4 border-t">
        <Pagination
          totalItems={pagination.total}
          itemsPerPage={pagination.limit}
          currentPage={pagination.page}
          onPageChange={onPageChange}
          onItemsPerPageChange={onLimitChange}
        />
      </div>
    </div>
  );
};

export default DuplicateClientsTable;